export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";